import React from 'react';
import Tooltip from '@/components/ui/Tooltip';
import Popover from '@/components/ui/Popover';
import { findChildByType } from '@/components/ui/ui.utils';
import {
  ButtonProps,
  buttonVariants,
  containerVariants,
  DropdownContentComponent,
  ButtonContentComponent,
} from './Button.utils';

const ButtonWithDropdown = ({
  ariaLabel,
  children,
  className,
  disabled = false,
  dropdownContent,
  ...props
}: ButtonProps) => {
  const dropdownContentOverride = findChildByType(children, ButtonWithDropdown.DropdownContent);
  const buttonContentOverride = findChildByType(children, ButtonWithDropdown.ButtonContent);

  return (
    <Tooltip.Provider>
      <Tooltip delayDuration={0}>
        <Popover>
          <div className={containerVariants({ dropdownButtonLocation: 'inside' })}>
            <Tooltip.Trigger asChild>
              <Popover.Trigger asChild>
                <button
                  aria-label={ariaLabel}
                  className={buttonVariants({ disabled, dropdownButtonLocation: 'inside' })}
                  disabled={disabled}
                  type="button"
                  {...props}
                >
                  <>
                    <ButtonContentComponent {...buttonContentOverride?.props} />
                    <div>
                      <div className="tw-rounded !tw-pl-2 tw-h-full tw-mr-0">
                        <i className="fa fa-caret-down" />
                      </div>
                    </div>
                  </>
                </button>
              </Popover.Trigger>
            </Tooltip.Trigger>
          </div>
          <Popover.Content
            align="start"
            className={dropdownContentOverride.props?.className}
            side="bottom"
            width="small"
          >
            <DropdownContentComponent {...dropdownContentOverride?.props} />
          </Popover.Content>
          <Tooltip.Content showArrow theme="white">
            {ariaLabel}
          </Tooltip.Content>
        </Popover>
      </Tooltip>
    </Tooltip.Provider>
  );
};

ButtonWithDropdown.DropdownContent = DropdownContentComponent;
ButtonWithDropdown.ButtonContent = ButtonContentComponent;

export default ButtonWithDropdown;
